// JoyRideContext.tsx
import React, { createContext, useContext } from 'react'
import { useJoyRide } from '@/utils/JoyRide'

const JoyRideContext = createContext<any>(null)

// disabled deja el contexto disponible pero sin tour: se usa al montar estos componentes dentro
// de un modal, donde el tooltip de Joyride se renderiza fuera del modal y cerrarlo lo cierra.
export const JoyRideProvider = ({ children, disabled = false }: { children: React.ReactNode, disabled?: boolean }) => {
  const joyride = useJoyRide()
  const value = disabled
    ? { ...joyride, JoyRideComponent: null, runTour: false, setRunTour: () => {}, setSteps: () => {} }
    : joyride
  return (
    <JoyRideContext.Provider value={value}>
      {!disabled && joyride.JoyRideComponent}
      {children}
    </JoyRideContext.Provider>
  )
}

export const useJoyRideContext = () => useContext(JoyRideContext)
